/* eslint-disable camelcase */
/* eslint-disable functional/prefer-readonly-type */
import {
  createState,
  none as noneValue,
  useState,
} from '@hookstate/core'
import { authFetch } from '~/services/fetch'
import IDispacthVehicle from '../interfaces/IDispacthVehicle'
import IVehicleList from '../interfaces/IVehicleList'
import { Broadcasted as broadcasted } from '@hookstate/broadcasted'

interface defaultActions {
  loading: boolean
  retryConnect: boolean,
  refreshVehicleListInDispatch: boolean
}

const vehicleListInDispatchState = createState<Array<IDispacthVehicle>>([])
const vehicleListInDispatchViewModeState = createState<Array<IDispacthVehicle>>([])
const vehicleListState = createState<Array<IVehicleList>>([])

vehicleListInDispatchState.attach(broadcasted('dispatch-vehicle-list'))
vehicleListState.attach(broadcasted('vehicle-list'))

const defaultActions: defaultActions = {
  loading: true,
  retryConnect: false,
  refreshVehicleListInDispatch: false,
}

const defaultActionsDefaultState = createState<defaultActions>(
  Object.create(defaultActions)
)

const useDispatchVehicleState = () => {
  const vehicleListInDispatch = useState(vehicleListInDispatchState)
  const vehicleList = useState(vehicleListState)
  const defaultActionsState = useState(defaultActionsDefaultState)
  const loading = useState(defaultActionsState.loading)
  const refreshVehicleListInDispatch = useState(defaultActionsState.refreshVehicleListInDispatch)
  const retryConnect = useState(defaultActionsState.retryConnect)

  function setDefaultvehicleListInDispatch(dispatchViewMode = false) {
    if (dispatchViewMode) {
      vehicleListInDispatchViewModeState.set([])
    } else {
      vehicleListInDispatch.set([])

    }
  }

  return {
    vehicleListInDispatch: () => vehicleListInDispatch,
    vehicleListInDispatchViewModeState: () => vehicleListInDispatchViewModeState,
    loading: loading,
    refreshVehicleListInDispatch: refreshVehicleListInDispatch,
    retryConnect: () => retryConnect,
    syncVehicleListInDispatch: async (dispatchId: string | number | null, dispatchViewMode = false) => {
      // retryConnect.set(false)
      loading.set(true)
      // setDefaultvehicleListInDispatch()

      if (!dispatchId) {
        loading.set(false)
        return false
      }

      try {
        const { data } = await authFetch({
          url: `/dispatch/devices-associated`,
          method: 'POST',
          data: {
            dispatch_id: dispatchId,
          },
        })

        if (!data) {
          dispatchViewMode ? vehicleListInDispatchViewModeState.set([]) : vehicleListInDispatch.set([])
          return true
        }

        if (dispatchViewMode) {
          vehicleListInDispatchViewModeState.set(data)
        } else {
          vehicleListInDispatch.set(data)
        }

        return true
      } catch (error) {
        return false
      } finally {
        loading.set(false)
      }
    },
    deleteVehicleFromList: (dispatchDeviceId: number) => {
      const targetDeviceStateArr = vehicleListInDispatch.filter(
        (deviceState) => {
          const device = deviceState.get()

          if (!device) return false

          if (device.id === dispatchDeviceId) return true

          return false
        }
      )
      const [targetDevice] = targetDeviceStateArr
      targetDevice.set(noneValue)
    },
    vehicleList: () => vehicleList,
    syncVehicleList: async (dispatchId: string | number | null) => {
      if (!dispatchId) return
      try {
        const { data } = await authFetch({
          url: `/dispatch/devices`,
          method: 'POST',
          data: {
            dispatch_id: parseInt(dispatchId.toString() ?? dispatchId),
          },
        })

        if (!data) return false
        vehicleList.set(data)

        return true
      } catch (error) {
        throw error
      }
    },
    updateStatusVehicleListInDispatch: ({
      dispatchDeviceId,
      status,
      dateUpdated,
    }) => {
      vehicleListInDispatch.keys.map((key) => {
        if (vehicleListInDispatch[key].id.get() == dispatchDeviceId) {
          vehicleListInDispatch[key]['status'].set(status)
          vehicleListInDispatch[key]['status_changed_at'].set(dateUpdated)
        }
      })
    },
    updateVehicleListInDispatch: ({ deviceSocketData }) => {

      const newValue = {
        id: deviceSocketData?.dispatch_device_id,
        dispatch_id: deviceSocketData?.dispatch_id,
        device: {
          id: deviceSocketData?.device.id,
          name: deviceSocketData?.device.name,
        },
        status: {
          id: deviceSocketData?.current_status.id,
          name: deviceSocketData?.current_status.name,
          acronym: deviceSocketData?.current_status.acronym,
        },
        status_changed_at: deviceSocketData?.current_date,
      }

      vehicleListInDispatch.set((prev) => [newValue, ...prev])
    },
    setDefaultvehicleListInDispatch: setDefaultvehicleListInDispatch,
  }
}

export default useDispatchVehicleState
